/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Archivemenusendbtn3Inputs */



/**
* | output |
* | --- |
* | "Move to archive" |
*
* @param {Archivemenusendbtn3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const archivemenusendbtn3 = /** @type {((inputs?: Archivemenusendbtn3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Archivemenusendbtn3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Move to archive")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mover al archivo")
	return /** @type {LocalizedString} */ ("Отправить в архив")
});
export { archivemenusendbtn3 as "archiveMenuSendBtn" }